import { useCallback, useState } from 'react';

export const useVisibilityContext = () => {
  const [visible, setVisibility] = useState<string[]>([]);
  const [userSetVisibility, setUserSetVisibility] = useState<string[]>([]);

  const register = useCallback(
    (name: string) => {
      if (visible.includes(name)) {
        return;
      }
      setVisibility((prev) => [...prev, name]);
      setUserSetVisibility((prev) => [...prev, name]);
    },
    [visible]
  );
  const toggle = useCallback(
    (name: string, source?: boolean) => {
      let newOrder = [...visible];
      const exists = newOrder.includes(name);
      if (exists) {
        newOrder = newOrder.filter((item) => item !== name);
      } else {
        newOrder.push(name);
      }
      setVisibility(newOrder);

      /* If toggle comes from Controls component then set as userPreference
       * This allows us to hide/show modules in search
       */
      if (source) {
        setUserSetVisibility(newOrder);
      }
    },
    [visible, setUserSetVisibility]
  );
  const isVisible = useCallback(
    (name: string) => {
      return visible.includes(name);
    },
    [visible]
  );

  const isUserPreferenceVisible = useCallback(
    (name: string) => {
      return userSetVisibility.includes(name);
    },
    [userSetVisibility]
  );

  return {
    visible,
    register,
    toggle,
    isVisible,
    userSetVisibility,
    isUserPreferenceVisible,
  };
};
